<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useInfiniteScroll } from '@vueuse/core'
import { rechargeCommonConfig } from './configs/common'
import RechargePageDefault from './components/RechargePage.default.vue'
import RechargePageFlipnovel from './components/RechargePage.flipnovel.vue'
import { api } from '@/api'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const config = rechargeCommonConfig

const RechargePage = loadBrandComponent({
  rocnovel: RechargePageDefault,
  oceread: RechargePageDefault,
  talewave: RechargePageDefault,
  ficmoon: RechargePageDefault,
  novelarc: RechargePageDefault,
  storyella: RechargePageDefault,
  silktale: RechargePageDefault,
  pearla: RechargePageDefault,
  fictora: RechargePageDefault,
  marinovel: RechargePageDefault,
  flipnovel: RechargePageFlipnovel,
})

const records = ref<any[]>([])
const page = ref(1)
const fetching = ref(false)
const ending = ref(false)
const error = ref<any>()
const pagination = computed(() => ({
  pageIndex: page.value,
  pageSize: 20,
}))
async function fetchFeed() {
  fetching.value = true
  try {
    const { data } = await api.get<any>('/member/topup/list', { params: { ...pagination.value } })
    records.value = [...records.value, ...data.records]
    if (page.value >= data.pages)
      ending.value = true
    else
      page.value += 1
  }
  catch (_error) {
    error.value = _error
  }
  finally {
    fetching.value = false
  }
}
const infiniteRef = ref<HTMLElement>()
function setInfiniteRef(el: HTMLElement | null) {
  infiniteRef.value = el || undefined
}
useInfiniteScroll(infiniteRef,
  async () => {
    if (fetching.value || ending.value || error.value)
      return
    await fetchFeed()
  },
  { distance: 50 },
)
</script>

<template>
  <RechargePage
    :config="config"
    :records="records"
    :fetching="fetching"
    :ending="ending"
    :page="page"
    :set-infinite-ref="setInfiniteRef"
  />
</template>
